import script from "./LogoutView.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoutView.vue?vue&type=script&setup=true&lang=js"

import "./LogoutView.vue?vue&type=style&index=0&id=09d09f58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09d09f58"]])

export default __exports__